import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";

// One-time intro splash with the REYCRO mark + loading sweep.
export const Splash = () => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setShow(false), 1700);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="splash"
          className="fixed inset-0 z-[10000] bg-black flex flex-col items-center justify-center"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
        >
          <motion.img
            src="https://customer-assets.emergentagent.com/job_racer-beats-pro/artifacts/sbsj2wrh_Icono%20Blanco.png"
            alt="REYCRO"
            className="h-20 w-auto"
            initial={{ opacity: 0, scale: 0.7, filter: "blur(8px)" }}
            animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          />
          <div className="mt-8 h-[2px] w-40 bg-white/10 overflow-hidden">
            <motion.div
              className="h-full bg-gradient-to-r from-[#BAF173] via-[#11E5B4] to-[#6735FA]"
              initial={{ x: "-100%" }}
              animate={{ x: "0%" }}
              transition={{ duration: 1.3, ease: "easeInOut" }}
            />
          </div>
          <motion.p
            className="mt-5 font-display text-[10px] uppercase tracking-[0.4em] text-white/40"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.6 }}
          >
            Built to move. Wired to create.
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
